const compactNumberFormat = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });

export function formatCompactNumber(value: number): string {
  return compactNumberFormat.format(value);
}

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export function formatLastVideoRelative(videoDate: string | null | undefined, now: Date): string {
  if (!videoDate) {
    return 'no videos';
  }
  const elapsedDays = Math.round((now.getTime() - new Date(videoDate).getTime()) / MILLISECONDS_PER_DAY);
  if (elapsedDays < 1) {
    return 'today';
  }
  if (elapsedDays < 60) {
    return `${elapsedDays} d ago`;
  }
  if (elapsedDays < 700) {
    return `${Math.round(elapsedDays / 30)} mo ago`;
  }
  return `${(elapsedDays / 365).toFixed(1)} y ago`;
}

export function getLastVideoSortValue(videoDate: string | null | undefined): number {
  return videoDate ? new Date(videoDate).getTime() : -Infinity;
}

export function withUrlScheme(url: string): string {
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

export function stripUrlScheme(url: string): string {
  return url.replace(/^https?:\/\//i, '');
}
